import { HttpClient } from '@/http-client';
import VueAuthPlugin from '@homeserve/vue-auth-plugin';
import Vue from 'vue';

Vue.use(VueAuthPlugin, {
  auth: {
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientID: process.env.VUE_APP_AUTH0_CLIENTID,
    audience: process.env.VUE_APP_AUTH0_AUDIENCE,
    responseType: 'token',
    scope: 'profile email',
    redirectUri:
      `${location.protocol}//${location.hostname}:${location.port}/callback` || 'http://localhost:8080/callback',
    clientCredentialUri: process.env.VUE_APP_BASE_URL + '/authenticateapp/',
  },
  http: HttpClient,
});
